import { Link, useNavigate, useLocation } from "react-router-dom";
import { SignupRequest } from "../services/authenticationServices";
import { useState, useEffect } from "react";
import CustomPopup from "../../src/Components/TermsPopup";

const Signup = () => {
  const IMG = (imgName) => {
    return `assets/landingpage/images/${imgName}`;
  };
  const navigate = useNavigate();
  const location = useLocation();

  const number = location.state?.phoneNumber;
  const firstNam = location.state?.firstName;

  const [isCondition, setisCondition] = useState(false);
  const [termsData, settermsData] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(number);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [firstName, setFirstName] = useState(firstNam);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    firstName: "",
    email: "",
    phoneNumber: "",
    password: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   validateForm();
  // }, [isSubmitted]);

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const newErrors = {
      firstName: "",
      email: "",
      phoneNumber: "",
      password: "",
    };

    // First Name validation
    if (!firstName.trim()) {
      newErrors.firstName = "Name is required";
    }

    // Email validation
    // if (!email) {
    //   newErrors.email = "Email is required";
    // } else if (!emailRegex.test(email)) {
    //   newErrors.email = "Please enter a valid email address";
    // }

    // Phone validation
    if (!phoneNumber) {
      newErrors.phoneNumber = "Mobile number is required";
    } else if (phoneNumber.length !== 10) {
      newErrors.phoneNumber = "Please enter a valid 10-digit mobile number";
    }

    // Password validation
    // if (!password) {
    //   newErrors.password = "Password is required";
    // } else if (password.length < 6) {
    //   newErrors.password = "Password must be at least 6 characters";
    // }

    setErrors(newErrors);
    // Return true only if there are no errors
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "firstName":
        setFirstName(value);
        break;
      case "email":
        setEmail(value.trim());
        break;
      case "phoneNumber":
        setPhoneNumber(value.trim());
        break;
      case "password":
        setPassword(value.trim());
        break;
    }

    if (isSubmitted) {
      validateForm();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    // First validate the form
    const isValid = validateForm();

    // Only proceed with API call if validation passes
    if (isValid) {
      setLoading(true);
      try {
        await SignupRequest(phoneNumber);
        navigate("/otp-verification", {
          state: {
            phoneNumber,
            from: "signup",
            email,
            password,
            firstName,
          },
        });
      } catch (error) {
        setErrors({
          ...errors,
          general: error.response?.data?.detail || "An error occurred",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <section className="vh-100">
      <div className="d-flex flex-column flex-md-row h-100 ">
        {/* Left Panel */}
        <div className="d-flex w-58 max-md-w-100 login-banner-container">
          <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
            <img
              loading="lazy"
              src="assets/landingpage/images/Login.jpg"
              alt="Login illustration"
              className="illustration-image"
              style={{
                mixBlendMode: "multiply",
              }}
            />
          </div>
        </div>

        {/* Right Panel */}
        <div className="flex-grow-1 d-flex align-items-center bg-white">
          <main className="login-signup-data d-flex flex-column justify-content-center py-4 h-100 w-100 text-lg font-bold bg-white">
            <div className="text-center">
              <a
                href="/"
                className="d-flex justify-content-center image-container"
                data-discover="true"
              >
                <img
                  loading="lazy"
                  src="assets/images/logo.svg"
                  alt="Company logo"
                  className="z-10  m-0  w-120 md-w-173   company-image"
                />
              </a>
              <h1 className="mt-3 text-dark fw-bold fs-1">Registration</h1>
            </div>

            <form className="w-100">
              {/* Mobile Number Field */}
              <div className="form__group">
                <input
                  type="number"
                  className={`form__field ${
                    isSubmitted && errors.phoneNumber ? "is-invalid" : ""
                  }`}
                  name="phoneNumber"
                  value={phoneNumber}
                  onChange={handleInputChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 10))
                  }
                  placeholder="Mobile Number"
                  id="new_mobile_number"
                  required
                  maxLength="10"
                />
                <label htmlFor="new_mobile_number" className="form__label">
                  Mobile<span className="text-danger">*</span>
                </label>
                <img
                  loading="lazy"
                  src="assets/landingpage/images/telephone.png"
                  alt=""
                  aria-hidden="true"
                  className="input-icon phone"
                />
              </div>
              {isSubmitted && errors.phoneNumber && (
                <div className="text-danger small mt-1">
                  {errors.phoneNumber}
                </div>
              )}

              {/* Email Input */}
              {/* <div className="form__group">
                <input
                  type="email"
                  className={`form__field ${
                    isSubmitted && errors.email ? "is-invalid" : ""
                  }`}
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  placeholder="Email"
                  id="email"
                  required
                  aria-required="true"
                />
                <label htmlFor="email" className="form__label">
                  Email<span className="text-danger">*</span>
                </label>
                <img
                  loading="lazy"
                  src="assets/landingpage/images/inbox.svg"
                  alt=""
                  aria-hidden="true"
                  className="input-icon"
                />
                
              </div>
              {isSubmitted && errors.email && (
                  <div className="text-danger small mt-1">{errors.email}</div>
                )} */}
              {/* Password Input */}
              {/* <div className="form__group">
                <input
                  type={showPassword ? "text" : "password"}
                  className={`form__field ${
                    isSubmitted && errors.password ? "is-invalid" : ""
                  }`}
                  name="password"
                  value={password}
                  onChange={handleInputChange}
                  placeholder="Password"
                  id="password"
                  required
                />
                <label htmlFor="password" className="form__label">
                  Password<span className="text-danger">*</span>
                </label>
                <img
                  loading="lazy"
                  src={`assets/landingpage/images/${
                    showPassword ? "eye-off.svg" : "eye.svg"
                  }`}
                  alt=""
                  style={{ padding: showPassword ? "6px" : "0px" }}
                  aria-hidden="true"
                  className="input-icon cursor-pointer"
                  onClick={togglePasswordVisibility}
                />
               
              </div>
              {isSubmitted && errors.password && (
                  <div className="text-danger small mt-1">
                    {errors.password}
                  </div>
                )} */}
              {/* First Name Input */}
              <div className="form__group">
                <input
                  type="text"
                  className={`form__field ${
                    isSubmitted && errors.firstName ? "is-invalid" : ""
                  }`}
                  name="firstName"
                  value={firstName}
                  onChange={handleInputChange}
                  placeholder="Name"
                  id="firstName"
                  required
                  aria-required="true"
                />
                <label htmlFor="firstName" className="form__label">
                  Name<span className="text-danger">*</span>
                </label>
                <img
                  loading="lazy"
                  src="assets/images/edit.svg"
                  alt=""
                  aria-hidden="true"
                  className="input-icon"
                  style={{width:"24px"}}
                 
                />
              </div>
              {isSubmitted && errors.firstName && (
                <div className="text-danger small mt-1">{errors.firstName}</div>
              )}

              <div className="login-status small text-danger d-flex my-3"></div>

              {/* Get OTP Button */}
              <button
                type="submit"
                className="btn btn-info text-white rounded-pill w-100 login-button"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? "Please wait..." : "Get OTP"}
              </button>
              {loading && (
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              )}
              {isSubmitted && errors.general && (
                <div className="text-danger small mt-2">
                  Error: {errors.general}
                </div>
              )}

              {/* Login Redirect */}
              <p className="text-center mt-3">
                Already have an account?{" "}
                <Link
                  to="/login"
                  className="text-info fw-bold text-decoration-none"
                >
                  Login
                </Link>
              </p>
            </form>
            <p className="terms">
                By using askmntor, you agree to our{" "}
                <span
                  className="condition"
                  onClick={() => {
                    settermsData("TermsData");
                    setisCondition(true);
                  }}
                >
                  Terms
                </span>{" "}
                and{" "}
                <span
                  className="condition"
                  onClick={() => {
                    settermsData("privacy");
                    setisCondition(true);
                  }}
                >
                  Privacy Policy
                </span>
                .
              </p>
            {isCondition && (
              <CustomPopup data={termsData} setisCondition={setisCondition} />
            )}
          </main>
        </div>
      </div>
    </section>
  );
};

export default Signup;
